export const common = {
  setupStatus: {
    completed: 'Completed',
    inProgress: 'In progress',
    needsAttention: 'Needs attention',
    notStarted: 'Not started'
  },
  actions: {
    save: 'Save',
    saving: 'Saving…',
    reset: 'Reset',
    cancel: 'Cancel',
    confirm: 'Confirm',
    next: 'Next',
    refresh: 'Refresh',
    close: 'Close'
  },
  rolloutGroup: {
    joinTitle: 'Your pharmacy has moved to the canary build',
    joinMessage: 'Reload now to switch over, or keep working and reload whenever it suits you.',
    leaveTitle: 'Your pharmacy has moved back to the stable build',
    leaveMessage: 'Reload now to switch back, or keep working -- this will apply the next time you reload.',
    reloadNow: 'Reload now',
    notNow: 'Not now'
  },
  newRelease: {
    bannerMessage: 'A new version of the portal is available.',
    later: 'Later'
  },
  errorPage: {
    newVersionTitle: 'A new version of the portal is available',
    newVersionMessage: 'Refresh to continue.',
    genericTitle: 'Something went wrong',
    genericMessage: 'An unexpected error occurred. Try refreshing the page, or go back to the home page.',
    goHome: 'Go home'
  },
  dataGrid: {
    customSortApplied: 'Custom Sort Applied',
    customSortAppliedDescription: 'This table is showing your saved sort order instead of the default. Dismiss to reset it.'
  },
  performanceTable: {
    tipsCompleted: 'TIPs Completed',
    cmrsCompleted: 'CMRs Completed',
    encounters: 'Encounters',
    tcmsCompleted: 'TCMs Completed',
    rpmsCompleted: 'RPMs Completed',
    invoicedTime: 'Invoiced Time',
    yourUtilizationRate: 'Your Utilization Rate',
    utilizationRate: 'Utilization Rate',
    noPerformanceDetails: 'No Performance Details',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly'
  }
} as const;
